export default "__VITE_ASSET__CPJ4qbCQ__"